import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebaseConfig.js';
import { getInfluencerByUserId } from '../models/influencer';
import type { AuthorSnapshot } from './types';

/**
 * Resolves denormalized author fields from influencers/{uid} with users/{uid} fallback.
 */
export async function buildAuthorSnapshot(userId: string): Promise<AuthorSnapshot> {
  const influencer = await getInfluencerByUserId(userId);
  const username =
    influencer?.username ||
    influencer?.identity?.handle ||
    (typeof influencer?.usernameLower === 'string' ? influencer.usernameLower : '') ||
    '';
  const displayName =
    influencer?.displayName ||
    influencer?.identity?.displayName ||
    '';
  const photoURL =
    influencer?.photoURL ||
    influencer?.profileImageUrl ||
    null;

  if (username || displayName || photoURL) {
    return {
      authorId: userId,
      authorUsername: username || userId.slice(0, 8),
      authorDisplayName: displayName || username || 'Creator',
      authorPhotoURL: photoURL,
    };
  }

  try {
    const userSnap = await getDoc(doc(db, 'users', userId));
    if (userSnap.exists()) {
      const u = userSnap.data();
      const uName =
        (typeof u.username === 'string' && u.username) ||
        (typeof u.displayName === 'string' && u.displayName) ||
        (typeof u.name === 'string' && u.name) ||
        userId.slice(0, 8);
      return {
        authorId: userId,
        authorUsername: typeof u.username === 'string' ? u.username : uName,
        authorDisplayName:
          (typeof u.displayName === 'string' && u.displayName) ||
          (typeof u.name === 'string' && u.name) ||
          uName,
        authorPhotoURL:
          (typeof u.photoURL === 'string' && u.photoURL) ||
          (typeof u.photoUrl === 'string' && u.photoUrl) ||
          null,
      };
    }
  } catch {
    /* fall through */
  }

  return {
    authorId: userId,
    authorUsername: userId.slice(0, 8),
    authorDisplayName: 'Creator',
    authorPhotoURL: null,
  };
}
